const HomeInitConditionConfig = {
    topAreaCode: "JABAR2",
    areaCode: "BANDUNG",
    cityName: "BANDUNG",
    cityCode: "BANDUNG",
    newProductClass : "MATIC"
};

export default HomeInitConditionConfig;
